import request from "../../utils/request";

export function signIn(params) {
  return request("/auth/login", {
    method: "POST",
    data: params,
  });
}

export function signInCompany(params) {
  return request("/auth/login-company", {
    method: "POST",
    data: params,
  });
}

export function signUp(params) {
  return request("/auth/register", {
    method: "POST",
    data: params,
  });
}

export function forgotPassword(params) {
  return request("/auth/reset-password", {
    method: "POST",
    data: params,
  });
}

export function resetPassword(params) {
  return request("/auth/confirm-reset", {
    method: "POST",
    data: params,
  });
}

export function setupAccount(params) {
  return request("/auth/setup-account", {
    method: "POST",
    data: params,
  });
}

export function updateUploadOrderTemplate(params) {
  return request("/auth/update-upload-order-template", {
    method: "POST",
    data: params,
  });
}

export function getProfile() {
  return request("/auth/profile", {
    method: "GET",
  });
}

export function getToken() {
  return request("/auth/token", {
    method: "GET",
  });
}
